import { useForm, UseFormProps, FieldValues } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import type { ZodTypeAny } from 'zod';

export function useZodForm<T extends FieldValues>(
  schema: ZodTypeAny,
  options?: Omit<UseFormProps<T>, 'resolver'>
) {
  return useForm<T>({
    ...options,
    resolver: zodResolver(schema),
  });
}
